import { render, staticRenderFns } from "./PeopleMediate.vue?vue&type=template&id=74d94ffd&"
import script from "./PeopleMediate.vue?vue&type=script&lang=js&"
export * from "./PeopleMediate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports